// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dmd-btn {
    transition: .25s box-shadow;
    padding: .5em;
    border: 2px solid rgba(0, 0, 0, .7);
    border-radius: 8px;
    background: rgba(255, 255, 255, .4);
    color: black;
    margin: 1px;
    box-shadow: 0.75px 1.25px rgba(100, 100, 100, .4);
    outline: none;
    font-family: 'Montserrat', sans-serif;
    font-weight: 700;
    text-transform: uppercase;
    font-size: 90%;
}
.dmd-btn:focus {
    outline: none;
}
.dmd-btn:hover {
    background: rgba(225, 225, 225, .4);
    border: 2px solid rgba(0, 0, 0, .3);
    box-shadow: 1.25px 2px rgba(100, 100, 100, .4);
}

.dmd-btn-blue {
    transition: all 150ms ease-in-out;
    position: relative;
    background: rgb(0, 119, 255);
    border: 2px solid rgb(0, 119, 255);
    z-index: 1;
    color: white;
}
.dmd-btn-blue:hover {
    color: rgb(0, 119, 255);
    box-shadow: 0 0 10px 0 rgb(0, 119, 255) inset, 0 0 10px 4px rgb(0, 119, 255);
    border: 2px solid rgb(0, 119, 255);
}

.dmd-btn-orange {
    transition: all 150ms ease-in-out;
    position: relative;
    background: rgb(255, 115, 0);
    border: 2px solid rgb(255, 115, 0);
    z-index: 1;
    color: white;
}
.dmd-btn-orange:hover {
    color: rgb(255, 115, 0);
    box-shadow: 0 0 10px 0 rgb(255, 115, 0) inset, 0 0 10px 4px rgb(255, 115, 0);
    border: 2px solid rgb(255, 115, 0);
}

.dmd-btn-alpha{
    padding: .1em .2em;
    border-radius:10px;
    border: 0;
    background:rgba(255,255,255,0);
    outline:none;
}
.dmd-btn-alpha:focus, .dmd-btn-switch:focus{
    outline:none;
}

.dmd-btn-switch {
    border:0;
    box-shadow: 0 0 1px 1px rgba(100,100,100,.5);
    padding: .5em;
    outline:none;
    font-size: 85%;
    color: rgb(40,40,40);
    font-weight: bold;
}

.dmd-btn-switch.on{
    background:rgb(40,250,40);
    box-shadow: 0 0 1px 1px rgba(100,255,100,.5);
}
`, "",{"version":3,"sources":["webpack://./css/dmd-btns.css"],"names":[],"mappings":"AAAA;IACI,2BAA2B;IAC3B,aAAa;IACb,mCAAmC;IACnC,kBAAkB;IAClB,mCAAmC;IACnC,YAAY;IACZ,WAAW;IACX,iDAAiD;IACjD,aAAa;IACb,qCAAqC;IACrC,gBAAgB;IAChB,yBAAyB;IACzB,cAAc;AAClB;AACA;IACI,aAAa;AACjB;AACA;IACI,mCAAmC;IACnC,mCAAmC;IACnC,8CAA8C;AAClD;;AAEA;IACI,iCAAiC;IACjC,kBAAkB;IAClB,4BAA4B;IAC5B,kCAAkC;IAClC,UAAU;IACV,YAAY;AAChB;AACA;IACI,uBAAuB;IACvB,4EAA4E;IAC5E,kCAAkC;AACtC;;AAEA;IACI,iCAAiC;IACjC,kBAAkB;IAClB,4BAA4B;IAC5B,kCAAkC;IAClC,UAAU;IACV,YAAY;AAChB;AACA;IACI,uBAAuB;IACvB,4EAA4E;IAC5E,kCAAkC;AACtC;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,SAAS;IACT,8BAA8B;IAC9B,YAAY;AAChB;AACA;IACI,YAAY;AAChB;;AAEA;IACI,QAAQ;IACR,4CAA4C;IAC5C,aAAa;IACb,YAAY;IACZ,cAAc;IACd,oBAAoB;IACpB,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,4CAA4C;AAChD","sourcesContent":[".dmd-btn {\n    transition: .25s box-shadow;\n    padding: .5em;\n    border: 2px solid rgba(0, 0, 0, .7);\n    border-radius: 8px;\n    background: rgba(255, 255, 255, .4);\n    color: black;\n    margin: 1px;\n    box-shadow: 0.75px 1.25px rgba(100, 100, 100, .4);\n    outline: none;\n    font-family: 'Montserrat', sans-serif;\n    font-weight: 700;\n    text-transform: uppercase;\n    font-size: 90%;\n}\n.dmd-btn:focus {\n    outline: none;\n}\n.dmd-btn:hover {\n    background: rgba(225, 225, 225, .4);\n    border: 2px solid rgba(0, 0, 0, .3);\n    box-shadow: 1.25px 2px rgba(100, 100, 100, .4);\n}\n\n.dmd-btn-blue {\n    transition: all 150ms ease-in-out;\n    position: relative;\n    background: rgb(0, 119, 255);\n    border: 2px solid rgb(0, 119, 255);\n    z-index: 1;\n    color: white;\n}\n.dmd-btn-blue:hover {\n    color: rgb(0, 119, 255);\n    box-shadow: 0 0 10px 0 rgb(0, 119, 255) inset, 0 0 10px 4px rgb(0, 119, 255);\n    border: 2px solid rgb(0, 119, 255);\n}\n\n.dmd-btn-orange {\n    transition: all 150ms ease-in-out;\n    position: relative;\n    background: rgb(255, 115, 0);\n    border: 2px solid rgb(255, 115, 0);\n    z-index: 1;\n    color: white;\n}\n.dmd-btn-orange:hover {\n    color: rgb(255, 115, 0);\n    box-shadow: 0 0 10px 0 rgb(255, 115, 0) inset, 0 0 10px 4px rgb(255, 115, 0);\n    border: 2px solid rgb(255, 115, 0);\n}\n\n.dmd-btn-alpha{\n    padding: .1em .2em;\n    border-radius:10px;\n    border: 0;\n    background:rgba(255,255,255,0);\n    outline:none;\n}\n.dmd-btn-alpha:focus, .dmd-btn-switch:focus{\n    outline:none;\n}\n\n.dmd-btn-switch {\n    border:0;\n    box-shadow: 0 0 1px 1px rgba(100,100,100,.5);\n    padding: .5em;\n    outline:none;\n    font-size: 85%;\n    color: rgb(40,40,40);\n    font-weight: bold;\n}\n\n.dmd-btn-switch.on{\n    background:rgb(40,250,40);\n    box-shadow: 0 0 1px 1px rgba(100,255,100,.5);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
